export default {
  /**
   * 指定した時間待機する
   * @param {number} msec 待機する時間(msec)
   * @return {Promise<void>}
   */
  sleep(msec: number) {
    return new Promise(resolve => {
      setTimeout(resolve, msec)
    })
  },
}
